module.exports = __webpack_public_path__ + "media/images/views/job/cdd-1-1098aa686a546a25591996484c0a438f.png";